import { TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';
import { ApplicationDispatch } from '@/store';

// Many reducers in this codebase are not fully typed.
// Keep selector typing permissive so TypeScript doesn't block builds.
export const useAppSelector: TypedUseSelectorHook<any> = useSelector;

export const useAppDispatch: () => ApplicationDispatch = useDispatch;
